export default __webpack_public_path__ + "static/media/logo-ace.ce93537a.jpg";